module.exports = {
  condition: 'លក្ខខណ្ឌ',
  display: 'បង្ហាញ',
  hide: 'លាក់',
  refresh: 'ធ្វើឱ្យស្រស់',
  import: 'នាំចូល',
  export: 'នាំចេញ',
  closure: 'បិទ',
  have: 'មាន',
  none: 'ទេ',
  confirm: 'កំណត់',
  cancel: 'បោះបង់',
  select: 'ជ្រើស',
  search: 'ស្វែងរក',
  prompt: 'ប្រអប់បញ្ចូល',
  returnIndex: 'ត្រឡប់ទៅទំព័រដើម',
  returnLastPage: 'ត្រឡប់មកវិញ',
  clearSearchOption: 'ជម្រះលក្ខខណ្ឌសំណួរ',
  operate: 'ប្រតិបត្តិការ',
  operatedSuccess: 'ប្រតិបត្តិការជោគជ័យ!',
  batchOperateSuccess: "ប្រតិបត្តិការបាច់បានទទួលជោគជ័យ!",
  requestedFail: 'សំណើបានបរាជ័យ!',
  operatedFail: 'ប្រតិបត្តិការបានបរាជ័យសូមព្យាយាមម្តងទៀត!',
  cancelOperate: 'អ្នកប្រើប្រាស់បានលុបចោលប្រតិបត្តិការ!',
  zhong: 'ភាសាចិន',
  ying: 'អង់គ្លេស',
  jian: 'ភាសាខ្មែរ',
  submit: 'ដាក់ស្នើ',
  required: 'សូមបំពេញក្នុងប៉ារ៉ាម៉ែត្រដែលត្រូវការ',
  edit: 'កែប្រែ',
  batchDelete: 'ការលុបបាច់',
  delete: 'លុប',
  add: 'បន្ថែមទៅ',
  top: 'កំពូល',
  selection_required: 'ជ្រើសរើសយ៉ាងហោចណាស់មួយ',
  enter_num_between: "សូមបញ្ចូលលេខចន្លោះពី {arg0} និង {arg1}",
  return: 'ត្រឡប់មកវិញ',
  upload_file: "ផ្ទុកឯកសារឡើង",
  upload_img: "ផ្ទុកឡើងរូបភាព",
  deleteVideo: "លុបវីដេអូ",
  upload_type_img: "គាំទ្រ {type} ប្រភេទរូបភាពនីមួយៗមិនលើសពី {size}",
  invalid_file_type: 'ទ្រង់ទ្រាយឯកសារមិនត្រឹមត្រូវ',
  upload_fail: "ការផ្ទុកឡើងបានបរាជ័យ",
  file_format_fail: 'កំហុសទ្រង់ទ្រាយឯកសារ',
  noData: 'គ្មានទិន្នន័យ',
  invalid_phone: 'សូមបញ្ចូលលេខទូរស័ព្ទចល័តមួយដែលត្រឹមត្រូវ',
  loading_map: 'កំពុងផ្ទុក',
  map_load_failed: "បានបរាជ័យក្នុងការផ្ទុកផែនទី,ធ្វើឱ្យស្រស់និងព្យាយាមម្តងទៀត",
  preview: "មើល",
  size: "ទំហំ",
  copy: 'ចម្លង',
  copySuccess: 'ចម្លងដោយជោគជ័យ',
  semicolon: '：',
  tipsSwitch: 'ប្រសិនបើមានរូបភាពច្រើនអ្នកអាចប្តូរបាន',
  lastWeek: 'មួយ​ស​ប្តា​ហ៍',
  lastMonth: 'មួយ​ខែ',
  lastTreeMonth: 'បីខែចុងក្រោយ',
  lastTwoMonth: 'ពីរខែចុងក្រោយ',
  today: 'ថ្ងៃនេះ',
  nextThreeDays: 'បីថ្ងៃបន្ទាប់',
  nextWeek: 'សប្តាហ៍ក្រោយ',
  nextMonth: 'ខែក្រោយ',
  nextStep: 'ជំហានបន្ទាប់',
  simplified: 'ភាសាចិនសាមញ្ញ',
  numberLetterRequired: '只能输入英文、数字组合'
}
